import * as React from 'react';
import { Link } from 'gatsby';
import type { MenuItem } from '@/types';

import {
  AndroidIcon,
  AppleIcon,
  WebIcon,
  RestIcon,
  UnityIcon,
  DownIcon,
  EdgeauthIcon,
  ReactIcon,
} from '../Icons';
import { docTiles } from '../../menus';
import './SDKSelector.styles.scss';

interface Selector {
  title: string;
  icon?: React.ReactElement;
}

interface SDKSelectorProps {
  pathname: string;
}

export const SDKSelector = ({ pathname }: SDKSelectorProps) => {
  const [show, set] = React.useState(false);
  const [docType, setDocType] = React.useState<Selector>({
    title: 'Web SDK',
    icon: <WebIcon />,
  });

  const data: Selector = pathname.includes('/web/')
    ? { title: 'Web SDK', icon: <WebIcon /> }
    : pathname.includes('/rest-api/')
    ? { title: 'REST API', icon: <RestIcon /> }
    : pathname.includes('/ios/')
    ? { title: 'iOS SDK', icon: <AppleIcon /> }
    : pathname.includes('/android/')
    ? { title: 'Android SDK', icon: <AndroidIcon /> }
    : pathname.includes('/unity/')
    ? { title: 'Unity SDK', icon: <UnityIcon /> }
    : pathname.includes('/react-native/')
    ? { title: 'React Native SDK', icon: <ReactIcon /> }
    : pathname.includes('/edgeauth/')
    ? { title: 'EdgeAuth SDK', icon: <EdgeauthIcon /> }
    : { title: 'Select an SDK' };

  React.useEffect(() => {
    setDocType(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  function handleClick() {
    set(false);
  }

  return (
    <div className="sdk-selector">
      <button onClick={() => set(!show)} className="flex align-center">
        {docType?.icon}
        <div>
          <div className="doc-category">{docType.title}</div>
        </div>
        <DownIcon />
      </button>
      <div id="sdk-options" className={show ? 'active' : undefined}>
        {docTiles.map(({ label, icon, path }: MenuItem, i: number) => (
          <Link key={i} to={path as string} onClick={handleClick}>
            {icon}
            <div>{label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};
